import { useState } from 'react'
import { EModalName } from '../../../types/enums'
import { Button } from '../../atoms'
import { InputPassword } from '../InputPassword'
import { formStyle, input, modalConent, submitButton } from './index.css'

export const ModalInputPassword = (props: {
  close: (result?: string) => void
}) => {
  const [result, setResult] = useState<string | undefined>(undefined)

  return (
    <form
      className={formStyle}
      onSubmit={() => props.close(result || undefined)}
    >
      <div className={modalConent}>
        <InputPassword
          placeholder='Password'
          value={result}
          className={input}
          onChange={setResult}
        />
      </div>
      <Button
        type='submit'
        variant='primary'
        analytic={{
          name: 'enter',
          params: {
            modal: EModalName.TABLE_PASSWORD_REQUEST,
          },
        }}
        className={submitButton}
      >
        Enter
      </Button>
    </form>
  )
}
